import React from "react";
import { useSelector } from "react-redux";

const AgingButton = ({ state, setState, aging }) => {
  const detailsStore = useSelector((state) => state.details);
  return (
    <button
      className="label aging aging-button"
      onClick={(e) => {
        setState({
          ...state,
          aging,
          showRCAgingModal: true,
        });
        e.stopPropagation();
      }}
      disabled={detailsStore.formLoading}
    >
      {aging}
    </button>
  );
};

export default AgingButton;
